import React, { useEffect } from 'react'
import { ERROR_DISPLAY_TYPES } from '../../constants'
import serverData from '../../utils/server-data'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  selectServiceErrorState,
  setHandledError,
} from '../../store/slices/handledErrorSlice'
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner'

const PageNotFound = React.lazy(() => import('../errors/PageNotFound'))
const FullScreenError = React.lazy(() => import('../errors/FullScreenError'))

const MainRouterPage = ({ children }: any) => {
  // Set any possible error code that should be handled (this only will run once, after component is mounted)
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(setHandledError({ status: serverData?.statusCode })(dispatch))
  }, [])

  // Get error code from store
  const statusCode = useAppSelector(
    ({ handledError }) => handledError.statusCode,
  )
  const serviceError = useAppSelector(selectServiceErrorState)

  // Show a loading spinner while app is loading
  if (statusCode === -1) {
    return <LoadingSpinner size="lg" />
  }
  if (statusCode === 404) {
    return <PageNotFound />
  }

  if (serviceError && serviceError.type === ERROR_DISPLAY_TYPES.FULLSCREEN) {
    return <FullScreenError {...serviceError} />
  }
  return <>{children}</>
}

export default MainRouterPage
